import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AngularMaterialModule } from 'src/app/material.module';
import { ValueFieldModule } from '../../../../lib/modules/value-field/value-field.module';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { AccountsService, SidePanelService } from '@lib/services';
import { QrScannerComponent } from '../qr-scanner/qr-scanner.component';
import { ConfirmationComponent } from '../confirmation/confirmation.component';
import { CardLessService } from '@lib/services/card-less/card-less.service';
import { IVoucherListIndex, VoucherOperationType } from '@lib/interfaces/card-less.interface';
import { ApiResponseError } from '@lib/interfaces';
import { BaseComponent } from '@lib/components';
import { MatSnackBar } from '@angular/material/snack-bar';
import { finalize, map } from 'rxjs';

@Component({
    selector: 'app-cash-in',
    templateUrl: './cash-in.component.html',
    styleUrls: ['./cash-in.component.scss'],
    standalone: true,
    imports: [AngularMaterialModule, ValueFieldModule],
    providers: [SidePanelService],
})
export class CashInComponent extends BaseComponent implements OnInit {
    code: FormControl<string> = this.formBuilder.nonNullable.control<string>('', [Validators.required]);
    loading = false;
    codeFailed = false;

    constructor(
        public dialogRef: MatDialogRef<CashInComponent>,
        private formBuilder: FormBuilder,
        private sidePanelService: SidePanelService,
        private cardLessService: CardLessService,
        private snackBarService: MatSnackBar,
        private accountService: AccountsService,
    ) {
        super();
    }

    ngOnInit() {
        this.removeExpiryErrorOnChange();
    }

    openCamera() {
        this.dialogRef.close();
        this.sidePanelService.open(QrScannerComponent);
    }

    removeExpiryErrorOnChange() {
        this.code.registerOnChange(() => {
            this.codeFailed = false;
        });
    }

    onContinue() {
        this.loading = true;
        this.cardLessService
            .voucherList({
                voucher_code: this.code.value.trim(),
                operation_code: VoucherOperationType.INWARD,
                limit: 1,
                after: '',
            })
            .pipe(
                map((response) => {
                    if (!response.data || response.data.length === 0) {
                        throw new Error('Voucher not found');
                    }

                    const voucher: IVoucherListIndex = response.data[0];
                    const expiryDate = new Date(voucher.expiry_time);

                    if (voucher.voucher_status === 'CANCELED') throw new Error('Voucher is canceled');
                    if (voucher.voucher_status === 'REDEEMED') throw new Error('Voucher is already redeemed');
                    if (new Date() > expiryDate) throw new Error('Voucher has expired');
                    if (!this.accountService.agentsAccounts().get(voucher.currency)) throw new Error(`Agent does not have ${voucher.currency} currency wallet. Please contact support`);
                    return response;
                }),

                finalize(() => {
                    this.loading = false;
                }),
            )
            .subscribe({
                next: ({ data }) => {
                    this.codeFailed = false;
                    this.dialogRef.close();
                    const dialogRef = this.sidePanelService.open(ConfirmationComponent);
                    dialogRef.componentInstance.screen = 'cash-in';
                    dialogRef.componentInstance.voucherInfo = data[0];
                },
                error: (error: ApiResponseError | Error) => {
                    if (error instanceof Error) {
                        if (error.message === 'Voucher has expired') {
                            this.codeFailed = true;
                            return;
                        }
                    }
                    this.createApiErrorSnackBar(this.snackBarService, error);
                },
            });
    }
}
